// extracted by mini-css-extract-plugin
export var contentBody = "_9a-9";
export var headerImage = "_9a-2";
export var imageButton = "_9a-7";
export var imageButtonIcon = "_9a-8";
export var imageHeader = "_9a-4";
export var imageHeaderText = "_9a-5";
export var imageOverlay = "_9a-3";
export var imageTitle = "_9a-6";
export var imageWrapper = "_9a-1";
export var taskList = "_9a-a";
export var widget = "_9a-0";